import { Image, View } from '@react-pdf/renderer';
import { useCallback } from 'react';

interface Props {
  logo: string | null | undefined;
}

export const PdfCompanyLogo = ({ logo }: Props) => {
  const getImage = useCallback(() => {
    if (logo) {
      return <Image src={'data:image/png;base64,' + logo} style={{ maxWidth: 200, maxHeight: 66 }} />;
    }
  }, [logo]);

  return <View style={{ borderWidth: 0.00001 }}>{getImage()}</View>;
};
